export const integrationTypes = {
    HUBSPOT: 'HUBSPOT',
    SHOPIFY: 'SHOPIFY',
    CUSTOM: 'CUSTOM'
};
